import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchWarehouse(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/show_warehouse/${warehouseId}`
    );
  },

  fetchInventoryMovements(
    serviceProviderId,
    warehouseId,
    currentPage,
    rowsPerPage
  ) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/show_warehouse/fetch_inventory_movements/${warehouseId}?current_page=${currentPage}&rows_per_page=${rowsPerPage}`
    );
  },

  fetchInventoryItems(serviceProviderId, warehouseId, params) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/show_warehouse/fetch_inventory_items/${warehouseId}`,
      { params }
    );
  },

  fetchInventoryUnits(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_items/fetch_inventory_units/${warehouseId}`
    );
  },
};
